import type { Company } from '@gokrew/models/company';
import type { ShortcutKey } from '@/utility/shortcuts';
import { companyDisplayName } from '@/utility/companyDisplayName';

/** The only name the switcher shows: the abbreviated one (see `companyDisplayName`). */
export const companyName = (company: Company) => companyDisplayName(company);

/** Search still matches the legal name, it is just never displayed. */
export const matchesCompanySearch = (company: Company, query: string) =>
  [company.abbreviatedName, company.legalName].some((name) =>
    name?.toLowerCase().includes(query)
  );

/** Opens the switcher panel from anywhere in the app. */
export const SWITCH_SHORTCUT: ShortcutKey[] = ['mod', 'J'];
